// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 991 ? "hse" : chunkId) + "." + {"548":"9a377bb9","991":"62efd455"}[chunkId] + ".chunk.css";
};